<script>
import axios from '@/utils/axios';
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';

export default {
  inject: ['setLoading'],
data() {
    return {
      salesOrder: null,
      admin: [],
      banks: [],
      showActionModal: false,
      clientAction: '',
      remarkByClient: '',
      actionErrors: {},
    };
},

  mounted() {
    const public_token = this.$route.params.public_token;
    this.loadSalesOrder(public_token);
  },

  methods: {
    async loadSalesOrder(public_token) {
    this.setLoading(true);
    try {
        const response = await axios.get(`sales-orders/${public_token}`);
        this.salesOrder = response.data.data;
        if (this.salesOrder?.admin_id) {
            this.adminDetail(this.salesOrder.admin_id);
            this.adminBanks(this.salesOrder.admin_id);
        }
    } catch (error) {
        this.$swalToast(error.message, 'error');
    } finally {
        this.setLoading(false);
    }
    },

    async downloadPDF() {
        await downloadPDFUtil('sales-orders', this.salesOrder.id);
    },

    async adminDetail(admin_id) {
        try {
            const response = await axios.get(`admin/${admin_id}`);
            this.admin = response.data.data;
        } catch (error) {
            console.log(error.message);
        }
    },

    async adminBanks(admin_id) {
        try {
            const response = await axios.get(`banks/${admin_id}`);
            this.banks = response.data.data;
        } catch (error) {
            console.log(error.message);
        }
    },
    openActionModal(action) {
        this.clientAction = action;
        this.remarkByClient = '';
        this.actionErrors = {};
        this.showActionModal = true;
    },

    closeActionModal() {
        this.showActionModal = false;
        this.clientAction = '';
        this.remarkByClient = '';
        this.actionErrors = {};
    },

    async submitAction() {
        this.actionErrors = {};

        if (!this.remarkByClient || this.remarkByClient.trim().length < 10) {
            this.actionErrors.remark = 'Please enter a remark (minimum 10 characters)';
            return;
        }

        this.setLoading(true);
        try {
            const response = await axios.post('sales-orders/action', {
                client_action: this.clientAction,
                public_token: this.salesOrder.public_token,
                remark_by_client: this.remarkByClient.trim(),
            });

            this.showActionModal = false;
            this.salesOrder.client_action = this.clientAction;
            this.salesOrder.remark_by_client = this.remarkByClient.trim();
        } catch (error) {
            if (error.response?.data?.errors) {
                this.actionErrors = error.response.data.errors;
            } else {
                alert(error.response?.data?.message || 'Failed to submit action');
            }
        } finally {
            this.setLoading(false);
        }
    },
    },
    };
</script>

<template>
  <div class="content" v-if="salesOrder">

    <!-- Top Bar -->
    <div class="d-md-flex d-block align-items-center justify-content-end page-breadcrumb mb-3 mt-3">
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
        <span class="badge bg-warning p-2">{{ salesOrder.status }}</span>
        <button class="btn btn-dark d-flex align-items-center" @click="downloadPDF">
          <i class="ti ti-download me-2"></i>Download PDF
        </button>
        <div class="dropdown" v-if="salesOrder.client_action !== 'approved' 
            && salesOrder.client_action !== 'rejected'
            && salesOrder.status === 'sent'">
          <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
            <i class="ti ti-grip-vertical me-2"></i> Action
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="javascript:void(0);" @click="openActionModal('approved')"><i class="ti ti-check me-2"></i> Approve</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="javascript:void(0);" @click="openActionModal('rejected')"><i class="ti ti-x me-2"></i> Reject</a></li>
          </ul>
        </div>
        <span v-if="salesOrder.client_action === 'approved'" class="badge bg-success p-2">Approved by Client</span>
        <span v-if="salesOrder.client_action === 'rejected'" class="badge bg-danger p-2">Rejected by Client</span>
      </div>
    </div>

    <!-- PDF Preview (same style as Blade template) -->
    <div style="width:185mm; min-height:297mm; margin:20px auto; background:#fff; border:1px solid #ccc; box-shadow:0 2px 12px rgba(0,0,0,0.10); font-family:'Segoe UI',Arial,sans-serif; font-size:13px; color:#333;">

      <!-- Title -->
      <div style="background:#444; color:#fff; text-align:center; font-size:18px; font-weight:700; letter-spacing:3px; padding:12px;">
        SALES ORDER
      </div>

      <!-- Company + Logo -->
      <table style="width:100%; border-collapse:collapse;">
        <tr>
         <td style="width:40%; padding:12px; border:1px solid #ddd; vertical-align:top;">
            <img :src="admin.company?.logo_url" :alt="admin.company?.company_name" style="width:180px; height:auto;">
        </td>
        <td style="width:60%; padding:12px; border:1px solid #ddd; text-align:right; vertical-align:top; line-height:1.6;">
            <h2 style="margin:0; font-size:18px; color:#222;">{{ admin?.company?.company_name }}</h2>
            <p v-if="admin.company?.gst" style="margin:2px 0;">GSTIN: <strong>{{ admin.company?.gst }}</strong></p>
            <p v-if="admin.company?.email" style="margin:2px 0;">Email: <strong>{{ admin.company?.email }}</strong></p>
            <p v-if="admin.company?.address" style="margin:2px 0;">Address: <strong>{{ admin.company?.address }}, {{ admin.company?.city }}, {{ admin.company?.state }}</strong></p>
            <p v-if="admin.company?.mobile" style="margin:2px 0;">Phone: <strong>{{ admin.company?.mobile }}</strong></p>
        </td>
        </tr>
      </table>

      <!-- Billing + SO Details -->
      <table style="width:100%; border-collapse:collapse;">
        <tr>
          <td style="width:50%; padding:12px; border:1px solid #ddd; vertical-align:top; line-height:1.6;">
            <strong style="font-size:15px;">Billing To</strong><br>
            {{ salesOrder.name }}<br>
            <span v-if="salesOrder.phone">{{ salesOrder.phone }}<br></span>
            <span v-if="salesOrder.email">{{ salesOrder.email }}<br></span>
            <span v-if="salesOrder.address">{{ salesOrder.address }}, </span>
            <span v-if="salesOrder.city">{{ salesOrder.city }}, </span>
            <span v-if="salesOrder.state">{{ salesOrder.state }} </span>
            <span v-if="salesOrder.pincode">{{ salesOrder.pincode }}</span>
          </td>
          <td style="width:50%; padding:12px; border:1px solid #ddd; vertical-align:top;">
            <table style="width:100%; border-collapse:collapse;">
              <tr>
                <td style="border:1px solid #ddd; padding:6px; text-align:center; width:50%;">
                  <strong>Sales Order Date</strong><br>
                  {{ $formatDate(salesOrder.created_at, 'DD-MMM-YYYY') }}
                </td>
                <td style="border:1px solid #ddd; padding:6px; text-align:center; width:50%;">
                  <strong>SO No</strong><br>
                  {{ salesOrder.so_number }}
                </td>
              </tr>
              <tr v-if="salesOrder.place_of_supply">
                <td colspan="2" style="border:1px solid #ddd; padding:6px; text-align:center;">
                  <strong>Place of Supply</strong><br>{{ salesOrder.place_of_supply }}
                </td>
              </tr>
              <tr v-if="salesOrder.shipment_date">
                <td colspan="2" style="border:1px solid #ddd; padding:6px; text-align:center;">
                  <strong>Shipment Date</strong><br>{{ $formatDate(salesOrder.shipment_date, 'DD-MMM-YYYY') }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <!-- Items Table -->
      <table style="width:100%; border-collapse:collapse; margin-top:15px;">
        <thead>
          <tr style="background:#f2f2f2;">
            <th style="border:1px solid #ddd; padding:6px;">S.No.</th>
            <th style="border:1px solid #ddd; padding:6px;">Title</th>
            <th style="border:1px solid #ddd; padding:6px;">HSN/SAC</th>
            <th style="border:1px solid #ddd; padding:6px;">Price</th>
            <th style="border:1px solid #ddd; padding:6px;">Quantity</th>
            <th style="border:1px solid #ddd; padding:6px;">Sub Total</th>
            <th v-if="salesOrder.tax_mode === 'item'" style="border:1px solid #ddd; padding:6px;">Tax</th>
            <th style="border:1px solid #ddd; padding:6px;">Final Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in salesOrder.sales_order_items" :key="item.id">
            <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{ index + 1 }}</td>
            <td style="border:1px solid #ddd; padding:6px; word-break:break-word;">
              {{ item.name }}
              <div v-if="item.description" v-html="item.description" style="font-size:12px; color:#666;"></div>
            </td>
            <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{ item.hsn_code || 'N/A' }}</td>
            <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{ parseFloat(item.unit_price || 0).toFixed(2) }}</td>
            <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{ item.quantity }} {{ item.unit }}</td>
            <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{ (item.quantity * item.unit_price).toFixed(2) }}</td>
            <td v-if="salesOrder.tax_mode === 'item'" style="border:1px solid #ddd; padding:6px; text-align:center;">{{ item.tax?.name || '' }}</td>
            <td style="border:1px solid #ddd; padding:6px; text-align:center; font-weight:600;">{{ parseFloat(item.total).toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Totals -->
      <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
        <tr>
          <td style="width:50%; padding:10px; border:1px solid #ddd;"></td>
          <td style="width:50%; padding:10px; border:1px solid #ddd; text-align:right; line-height:1.8;">
            <strong>Sub Total &nbsp;&nbsp;</strong> {{ parseFloat(salesOrder.subtotal).toFixed(2) }}<br>
            <span v-if="salesOrder.tax_amount > 0">
              <strong>Tax &nbsp;&nbsp;</strong> {{ parseFloat(salesOrder.tax_amount).toFixed(2) }}<br>
            </span>
            <span v-if="salesOrder.discount > 0">
              <strong>Discount &nbsp;&nbsp;</strong> {{ parseFloat(salesOrder.discount).toFixed(2) }}<br>
            </span>
            <span v-if="salesOrder.shipping_charges > 0">
              <strong>Shipping &nbsp;&nbsp;</strong> {{ parseFloat(salesOrder.shipping_charges).toFixed(2) }}<br>
            </span>
            <strong>Total &nbsp;&nbsp;</strong> {{ salesOrder.party?.currency?.code }} {{ parseFloat(salesOrder.total).toFixed(2) }}
          </td>
        </tr>
      </table>

      <!-- Terms -->
      <table v-if="salesOrder.terms" style="width:100%; border-collapse:collapse; margin-top:15px;">
        <tr>
          <td style="border:1px solid #ddd; padding:10px; line-height:1.6;">
            <strong><u>Terms & Conditions</u></strong>
            <div v-html="salesOrder.terms"></div>
          </td>
        </tr>
      </table>

      <!-- Notes + Signature -->
      <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
        <tr>
          <td style="width:60%; padding:10px; border:1px solid #ddd; vertical-align:top;">
            <div v-if="salesOrder.notes">
              <strong>Note:</strong>
              <div v-html="salesOrder.notes"></div>
            </div>
          </td>
          <td style="width:40%; padding:10px; border:1px solid #ddd; text-align:right; vertical-align:bottom;">
            <p style="margin:2px 0;">{{ admin.company?.company_name }}</p>
            <img v-if="admin.company?.signature_url" :src="admin.company?.signature_url" style="width:120px; height:auto; margin-bottom:5px;"><br>
            <strong style="font-size:15px;">Authorised Signatory</strong>
        </td>
        </tr>
      </table>

      <!-- Sales Person -->
      <table style="width:100%; border-collapse:collapse; margin-top:15px;">
        <tr>
          <td style="border:1px solid #ddd; padding:10px; line-height:1.6;">
            <strong>Sales Person Info</strong><br>
            {{ salesOrder.created_by?.name }}<br>
            {{ salesOrder.created_by?.email }}<br>
            {{ salesOrder.created_by?.mobile }}
          </td>
        </tr>
      </table>

    </div>
  </div>



  <!-- Action Modal -->
    <div class="modal fade" :class="{ show: showActionModal }"
        :style="showActionModal ? 'display:block;z-index:1060;' : 'display:none'" tabindex="0">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
                <div class="modal-header" style="padding:14px 18px;border-bottom:1px solid #f0f1f5;background:#f8f9fb;">
                    <h6 class="fw-bold mb-0" style="font-size:14px;">
                        {{ clientAction === 'approved' ? 'Approve Sales Order' : 'Reject Sales Order' }}
                    </h6>
                    <button type="button" class="btn-close" @click="closeActionModal"></button>
                </div>
                <div class="modal-body" style="padding:20px;">
                    <div class="mb-3">
                        <label style="font-size:12px;font-weight:600;color:#475569;margin-bottom:6px;display:block;">
                            Remark <span style="color:#f43f5e;">*</span>
                        </label>
                        <textarea class="form-control" rows="3" v-model="remarkByClient"
                            placeholder="Enter your remark..." style="font-size:13px;"></textarea>
                        <div v-if="actionErrors.remark" style="font-size:11px;color:#f43f5e;margin-top:4px;">
                            {{ actionErrors.remark }}
                        </div>
                        <div v-if="actionErrors.remark_by_client" style="font-size:11px;color:#f43f5e;margin-top:4px;">
                            {{ actionErrors.remark_by_client[0] }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer" style="padding:12px 18px;border-top:1px solid #f0f1f5;">
                    <button type="button" class="btn btn-sm btn-light" @click="closeActionModal">Cancel</button>
                    <button type="button" class="btn btn-sm d-flex align-items-center gap-1"
                        :class="clientAction === 'approved' ? 'btn-success' : 'btn-danger'"
                        @click="submitAction">
                        <i :class="clientAction === 'approved' ? 'ti ti-check' : 'ti ti-x'"></i>
                        {{ clientAction === 'approved' ? 'Approve' : 'Reject' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-if="showActionModal" class="modal-backdrop fade show" style="z-index:1055;" @click="closeActionModal"></div>
</template>